import React, { useState, useEffect, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import LayoutWithAccountCard from '../../../../layout/Layout/layout-account-card'
import { useModal } from 'react-modal-hook'
import BeneficiaryTransferService from '../../../../services/beneficiary-transfers.service'
import { Row, Col } from 'react-bootstrap'
import NeoButton from '../../../../components/NeoButton/NeoButton'
import Loading from 'custom/assets/loaders/Loading'
import '../../../../styles/beneficiary.css'
import LargeModel from '../../../../components/Modal/largeModel'
import PlusIcon from 'custom/assets/common-icons/plus.svg'
import BeneIcon from 'custom/assets/common-icons/bene-image.svg'
import { useTranslation } from 'react-i18next'
import {
  BENEFICIARY_TRANSFER_KEYS,
  DEPOSITS_KEYS,
  DIALOG_KEYS,
} from '../../../../utils/translation-constants'
import NumberFormat from 'react-number-format'
import envConfig from 'custom/config/environment'

const tabList = envConfig.BENEFICIARY_TRANSFER_TABS.filter((ele) => !['OWN'].includes(ele))

export default function BeneficiaryView() {
  const history = useHistory()
  const [stage, setStage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [internalBeneList, setInternalBeneList] = useState([])
  const [otherBeneList, setOtherBeneList] = useState([])
  const [regionalBeneList, setRegionalBeneList] = useState([])
  const [internationalBeneList, setInternationalBeneList] = useState([])
  const [selectedBeneDetails, setSelectedBeneDetails] = useState({})
  const [searchTerm, setSearchTerm] = useState([])
  const [listOfBen, setListOfBen] = useState()
  const { t } = useTranslation()

  const TABS = {
    INTERNAL: {
      label: t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.WITH_IN_BANK),
      stage: 1,
    },
    DOMESTIC: {
      label: t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.DOMESTIC),
      stage: 2,
    },
    INTERNATIONAL: {
      label: t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.INTERNATIONAL),
      stage: 3,
    },
    REGION: {
      label: t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.REGIONAL),
      stage: 4,
    },
  }

  const transferTypes = {
    IAT: t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_DETAILS_KEYS.INTERNAL),
    THIRD_PARTY: t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_DETAILS_KEYS.OTHER),
    INTERNATIONAL: t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_DETAILS_KEYS.INTERNATIONAL),
    REGION: t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.REGIONAL),
  }
  const [showBeneView, hideBeneView] = useModal(
    () => (
      <LargeModel>
        <div align='right'>
          {/* <h5>Beneficiary Details</h5> */}
          <i
            className='material-icons'
            onClick={() => {
              hideBeneView()
            }}
            style={{ marginTop: -5, cursor: 'pointer' }}>
            close
          </i>
        </div>
        <div className='row beneficiary-details'>
          <div className='col-2'>
            <img
              style={{
                height: 80,
                width: 80,
                margin: '0 auto',
                objectFit: 'contain',
                display: 'block',
              }}
              src={selectedBeneDetails?.image === null ? BeneIcon : selectedBeneDetails?.image}
            />
          </div>
          <div className='col-10'>
            <div className='row'>
              <div className='col-4'>
                <div className='label'>
                  {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.NAME1)}
                </div>
                <div className='value'>{selectedBeneDetails?.beneName}</div>
              </div>
              <div className='col-4'>
                <div className='label'>
                  {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.ACCOUNT_NUMBER1)}
                </div>
                <div className='value'>{selectedBeneDetails?.beneAccNo}</div>
              </div>
              <div className='col-4'>
                <div className='label'>
                  {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.TRANSFER_LIMIT1)}
                </div>
                <div className='value'>
                  <NumberFormat
                    value={selectedBeneDetails?.maxTransferLimit}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={''}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    allowEmptyFormatting
                  />{' '}
                  {selectedBeneDetails?.beneCurrency}
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-4'>
                <div className='label'>{t(DEPOSITS_KEYS.TERM_DEPOSITS_DETAILS_KEYS.brnCode)} </div>
                <div className='value'>{selectedBeneDetails?.beneBrn || '-'}</div>
              </div>
              <div className='col-4'>
                <div className='label'>
                  {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BENE_EMAIL1)}
                </div>
                <div className='value' style={{ wordBreak: 'break-all' }}>
                  {selectedBeneDetails?.beneEMail || '-'}
                </div>
              </div>
              <div className='col-4'>
                <div className='label'>
                  {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BENE_MOBILE1)}
                </div>
                <div className='value'>{selectedBeneDetails?.beneMobileNo || '-'}</div>
              </div>
            </div>

            <div className='row'>
              <div className='col-4'>
                <div className='label'>
                  {t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_DETAILS_KEYS.NICK_NAME)}
                </div>
                <div className='value'>{selectedBeneDetails?.shortName}</div>
              </div>
              <div className='col-4'>
                <div className='label'>
                  {t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_DETAILS_KEYS.BENE_TYPE)}
                </div>
                <div className='value'>{transferTypes[selectedBeneDetails?.beneType]}</div>
              </div>
            </div>
            <div className='row'>
              <div className='col-5'>
                <NeoButton
                  mode='newDesign'
                  type='button'
                  onClick={() => handleModifyBene()}
                  text={t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_DETAILS_KEYS.EDIT_BEN)}
                />
              </div>
              <div className='col-5'>
                <div className='delete-btn' onClick={() => handleMakePayment()}>
                  {t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_DETAILS_KEYS.MAKE_PAYMENT)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </LargeModel>
    ),
    [selectedBeneDetails],
  )

  useEffect(() => {
    fetchBeneficiaries()
  }, [])

  const handleMakePayment = useCallback(() => {
    try {
      history.push({
        pathname: `/beneficiary-transfers/transfers/${
          selectedBeneDetails?.beneType === 'IAT'
            ? 'internal'
            : selectedBeneDetails?.beneType === 'INBK'
            ? 'internal'
            : selectedBeneDetails?.beneType === 'DDACC'
            ? 'other'
            : selectedBeneDetails?.beneType === 'RTGS'
            ? 'other'
            : selectedBeneDetails?.beneType === 'THIRD_PARTY'
            ? 'other'
            : selectedBeneDetails?.beneType === 'REGION'
            ? 'regional'
            : 'international'
        }`,
        state: {
          beneDetails: selectedBeneDetails,
          transferType: '',
        },
      })
    } catch (err) {}
  }, [selectedBeneDetails])

  const handleModifyBene = useCallback(() => {
    try {
      history.push({
        pathname: `/beneficiary-transfers/edit-beneficiary/${
          selectedBeneDetails?.beneType === 'IAT'
            ? 'internal'
            : selectedBeneDetails?.beneType === 'INBK'
            ? 'internal'
            : selectedBeneDetails?.beneType === 'DDACC'
            ? 'other'
            : selectedBeneDetails?.beneType === 'RTGS'
            ? 'other'
            : selectedBeneDetails?.beneType === 'THIRD_PARTY'
            ? 'other'
            : selectedBeneDetails?.beneType === 'REGION'
            ? 'regional'
            : 'international'
        }`,
        state: {
          beneDetails: selectedBeneDetails,
          transferType: '',
        },
      })
    } catch (err) {}
  }, [selectedBeneDetails])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderInternalBene()
      case 2:
        return renderOtherBene()
      case 3:
        return renderInternationalBene()
      case 4:
        return renderRegionalBene()
      default:
        return renderInternalBene()
    }
  }

  const fetchBeneficiaries = useCallback(async () => {
    try {
      setLoading(true)
      const response = await BeneficiaryTransferService.getAllBeneficiaries()
      if (response.status === 200) {
        setListOfBen(response.data)
        setInternalBeneList(response.data['internalBeneficiaries'])
        setInternationalBeneList(
          response.data['thirdPartyBeneficiaries'].filter(
            (ele) => ele.beneType === 'INTERNATIONAL',
          ),
        )
        setOtherBeneList(
          response.data['thirdPartyBeneficiaries'].filter((ele) => ele.beneType === 'THIRD_PARTY'),
        )
        setRegionalBeneList(
          response.data['thirdPartyBeneficiaries'].filter((ele) => ele.beneType === 'REGION'),
        )
      }
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const handleSearchChange = useCallback(
    (e) => {
      setSearchTerm(e.target.value)
      if (stage === 1) {
        if (e.target.value === '') {
          setInternalBeneList(listOfBen.internalBeneficiaries)
        } else
          setInternalBeneList(
            listOfBen.internalBeneficiaries.filter((v) => {
              return v.shortName.toLowerCase().includes(e.target.value.toLowerCase())
            }),
          )
      } else if (stage === 2) {
        if (e.target.value === '') {
          setOtherBeneList(
            listOfBen.thirdPartyBeneficiaries.filter((ele) => ele.beneType === 'THIRD_PARTY'),
          )
        } else
          setOtherBeneList(
            listOfBen.thirdPartyBeneficiaries
              .filter((ele) => ele.beneType === 'THIRD_PARTY')
              .filter((v) => {
                return v.shortName.toLowerCase().includes(e.target.value.toLowerCase())
              }),
          )
      } else if (stage === 3) {
        if (e.target.value === '') {
          setInternationalBeneList(
            listOfBen.thirdPartyBeneficiaries.filter((ele) => ele.beneType === 'INTERNATIONAL'),
          )
        } else
          setInternationalBeneList(
            listOfBen.thirdPartyBeneficiaries
              .filter((ele) => ele.beneType === 'INTERNATIONAL')
              .filter((v) => {
                return v.shortName.toLowerCase().includes(e.target.value.toLowerCase())
              }),
          )
      } else if (stage === 2) {
        if (e.target.value === '') {
          setRegionalBeneList(
            listOfBen.thirdPartyBeneficiaries.filter((ele) => ele.beneType === 'REGION'),
          )
        } else
          setRegionalBeneList(
            listOfBen.thirdPartyBeneficiaries
              .filter((ele) => ele.beneType === 'REGION')
              .filter((v) => {
                return v.shortName.toLowerCase().includes(e.target.value.toLowerCase())
              }),
          )
      }
    },
    [stage, listOfBen],
  )

  useEffect(() => {
    setSearchTerm('')
  }, [stage])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  const handleBeneDetails = useCallback(async (selected) => {
    setSelectedBeneDetails(selected)
    showBeneView()
  }, [])

  function renderInternalBene() {
    return (
      <>
        <Row>
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            onClick={() => history.push('/beneficiary-transfers/add-beneficiary')}
            className='bene-card'>
            <img width={30} height={30} src={PlusIcon} />
            <span style={{ color: 'var(--secondary_1)' }}>
              {t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.ADD_NEW)}
            </span>
          </Col>
          {internalBeneList.map((item, index) => (
            <Col
              xs={'auto'}
              sm={'auto'}
              md={'auto'}
              key={index}
              onClick={() => handleBeneDetails(item)}
              className='bene-card'>
              <img
                style={{ height: 30, width: 30, margin: '0 auto', objectFit: 'contain' }}
                src={item.image === null ? BeneIcon : item.image}
              />
              <span>{item.shortName}</span>
            </Col>
          ))}
        </Row>
      </>
    )
  }

  function renderOtherBene() {
    return (
      <>
        <Row>
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            onClick={() => history.push('/beneficiary-transfers/add-beneficiary')}
            className='bene-card'>
            <img width={30} height={30} src={PlusIcon} />
            <span style={{ color: 'var(--secondary_1)' }}>
              {t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.ADD_NEW)}
            </span>
          </Col>
          {otherBeneList.map((item, index) => (
            <Col
              xs={'auto'}
              sm={'auto'}
              md={'auto'}
              key={index}
              onClick={() => handleBeneDetails(item)}
              className='bene-card'>
              <img
                style={{ height: 30, width: 30, margin: '0 auto', objectFit: 'contain' }}
                src={item.image === null ? BeneIcon : item.image}
              />
              <span>{item.shortName}</span>
            </Col>
          ))}
        </Row>
      </>
    )
  }

  function renderInternationalBene() {
    return (
      <>
        <Row>
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            onClick={() => history.push('/beneficiary-transfers/add-beneficiary')}
            className='bene-card'>
            <img width={30} height={30} src={PlusIcon} />
            <span style={{ color: 'var(--secondary_1)' }}>
              {t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.ADD_NEW)}
            </span>
          </Col>
          {internationalBeneList.map((item, index) => (
            <Col
              xs={'auto'}
              sm={'auto'}
              md={'auto'}
              key={index}
              onClick={() => handleBeneDetails(item)}
              className='bene-card'>
              <img
                style={{ height: 30, width: 30, margin: '0 auto', objectFit: 'contain' }}
                src={item.image === null ? BeneIcon : item.image}
              />
              <span>{item.shortName}</span>
            </Col>
          ))}
        </Row>
      </>
    )
  }

  function renderRegionalBene() {
    return (
      <>
        <Row>
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            onClick={() => history.push('/beneficiary-transfers/add-beneficiary')}
            className='bene-card'>
            <img width={30} height={30} src={PlusIcon} />
            <span style={{ color: 'var(--secondary_1)' }}>
              {t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.ADD_NEW)}
            </span>
          </Col>
          {regionalBeneList.map((item, index) => (
            <Col
              xs={'auto'}
              sm={'auto'}
              md={'auto'}
              key={index}
              onClick={() => handleBeneDetails(item)}
              className='bene-card'>
              <img
                style={{ height: 30, width: 30, margin: '0 auto', objectFit: 'contain' }}
                src={item.image === null ? BeneIcon : item.image}
              />
              <span>{item.shortName}</span>
            </Col>
          ))}
        </Row>
      </>
    )
  }

  return (
    <LayoutWithAccountCard breadCumKey='BENE_VIEW'>
      <div className='view-beneficiary-list'>
        <h4>{t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.VIEW_BENEFICIARIES_TITLE)}</h4>
        <div className='row bene-navbar d-flex justify-content-between'>
          {tabList.map((option, index) => (
            <div
              key={index}
              className={
                stage === TABS[option]['stage']
                  ? `col-${12 / tabList.length} selected`
                  : `col-${12 / tabList.length}`
              }>
              <span onClick={() => setStage(TABS[option]['stage'])}>{TABS[option]['label']}</span>
            </div>
          ))}

          {/* <div className={stage === 1 ? 'col-4 selected' : 'col-4'}>
            <span onClick={() => setStage(1)}>Within Bank</span>
          </div>
          <div className={stage === 2 ? 'col-4 selected' : 'col-4'}>
            <span onClick={() => setStage(2)}>Domestic</span>
          </div>
          <div className={stage === 3 ? 'col-4 selected' : 'col-4'}>
            <span onClick={() => setStage(3)}>International</span>
          </div> */}
        </div>
        <div>
          <input
            className='mb-3 col-12 search-box'
            name='search'
            placeholder={t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.SEARCH)}
            type='search'
            onChange={handleSearchChange}
            value={searchTerm}
          />
        </div>
      </div>
      {loading && renderLoading()}
      <div>{!loading && renderSwitch()}</div>
    </LayoutWithAccountCard>
  )
}
